import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-component-loading',
    templateUrl: './loading.component.html',
    styleUrls: ['./loading.component.scss']
})
export class LoadingComponent {
    /* default / inline */
    @Input() public size = 'default';
    @Input() public margin:number = 15;

    constructor() {
    }

}
